import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const POLL_INTERVAL = 2000;
const MAX_ATTEMPTS = 10;

/** Polls Stripe session status until paid/expired/failed. */
export default function usePaymentPoll(sessionId) {
  const [state, setState] = useState("polling"); // polling | paid | failed | expired
  const [coin, setCoin] = useState({ slug: null, name: "", ticker: "" });
  const [sku, setSku] = useState(null);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) {
      setState("failed");
      return;
    }
    let cancelled = false;
    let n = 0;

    const bump = () => {
      n += 1;
      setAttempts(n);
      if (n >= MAX_ATTEMPTS) {
        setState("failed");
        return false;
      }
      setTimeout(poll, POLL_INTERVAL);
      return true;
    };

    const poll = async () => {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setCoin({
            slug: data.coin_slug,
            name: data.coin_name || data.coin_slug || "",
            ticker: data.coin_ticker || "",
          });
          setSku(data.sku || null);
          setState("paid");
          return;
        }
        if (data.status === "expired") {
          setState("expired");
          return;
        }
        bump();
      } catch {
        // Transient network/5xx during polling — retry until MAX_ATTEMPTS.
        bump();
      }
    };
    poll();
    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return { state, coin, sku, attempts, maxAttempts: MAX_ATTEMPTS };
}
